import React from "react";

// utilities
import axios from '../../../utils/axios';

export const StoreContext = React.createContext();
export const useStore = () => React.useContext(StoreContext);

export const StoreProvider = ({children}) => {

  const [storesList, setStoresList] = React.useState([]);
  const [storeState, setStoreState] = React.useState({
    id: "1",
    name: "6thstreet",
    base_url: "https://6thadmin-stage.6tst.com",
    api_key: "dngskuc3pp5z8thom5ct6fsz2vx0cd3n"
  });

  const fetchStoresList = async () => {
    try{
        const fetchStoresResponse = await axios.get(`/api/recan/config/store/getlist`);
        if(fetchStoresResponse.data.success){
            setStoresList(
              fetchStoresResponse.data.payload.items.map((store) => {
                return {
                  id: store.id,
                  name: store.store_name,
                  base_url: store.base_url,
                  api_key: store.api_key
                }
              }
            )
          );
        }
    }
    catch(err){
        console.error(err);
    }
  }

  const setStore = (id, name, base_url, api_key) => {
    setStoreState({
      id,
      name,
      base_url,
      api_key
    })
    window.localStorage.setItem("ReCan:currentStoreID", id);
    window.localStorage.setItem("ReCan:currentStoreName", name);
    window.localStorage.setItem("ReCan:currentStoreBaseURL", base_url);
    window.localStorage.setItem("ReCan:currentStoreAPIKey", api_key);
  }

  const createNewStore = async (name, url, apiKey) => {
    try{
      const createNewStoreResponse = await axios.post('/api/recan/config/store/save', {
        store_name: name,
        base_url: url,
        api_key: apiKey
      });
      if(createNewStoreResponse.data.success){
        await fetchStoresList();
        return new Promise((resolve) => resolve())
      }
      return new Promise((resolve, reject) => reject(createNewStoreResponse.data))
    }
    catch(err){
      return new Promise((resolve, reject) => reject(err))
    }
  }

  React.useState(() => {
    fetchStoresList();
    const id = window.localStorage.getItem("ReCan:currentStoreID");
    const name = window.localStorage.getItem("ReCan:currentStoreName");
    const base_url = window.localStorage.getItem("ReCan:currentStoreBaseURL");
    const api_key = window.localStorage.getItem("ReCan:currentStoreAPIKey");
    if(id && name && base_url && api_key){
      setStore(id, name, base_url, api_key);
    }
  }, []);

  return (
    <StoreContext.Provider
      value={{
        storesList,
        storeState,
        setStoreState: setStore,
        createNewStore
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};